var current = jQuery('#matches .matches-wrapper').length > 0 ? jQuery('#matches .matches-wrapper').data().startpoint : 1;
var currentGame = jQuery('#games .matches-wrapper').length > 0 ? jQuery('#games .matches-wrapper').data().startpoint : 1;

function initMatchesBar(c){
  current=c;
  var limit = jQuery(".small-bar").length>0 ? 5 : 9;
  if(current==1)
    jQuery('.slide-win-prev').css('visibility', 'hidden');
  if(current+limit>jQuery('#matches .match-wrapper').length)
    jQuery('.slide-win-next').css('visibility', 'hidden');
}

function nextMatch(){
  var wrap = jQuery('#matches .match-wrapper');
  var btn_next = jQuery('.slide-win-next');
  var btn_prev = jQuery('.slide-win-prev');
  var limit = jQuery(".small-bar").length>0 ? 5 : 9;
  if(current>0)
    btn_prev.css('visibility', 'visible');
  if(current<(wrap.length-limit))
    btn_next.css('visibility', 'visible');
  else
    btn_next.css('visibility', 'hidden');
  if(current<(wrap.length-(limit-1))){
    var el=wrap.get(current-1);
    jQuery(el).stop(true,true).animate({marginLeft: -114}, 500);
    current++;
  }
}

function prevMatch(){
  var wrap = jQuery('#matches .match-wrapper');
  var btn_next = jQuery('.slide-win-next');
  var btn_prev = jQuery('.slide-win-prev');
  var limit = jQuery(".small-bar").length>0 ? 3 : 7;
  if(current<(wrap.length-limit))
    btn_next.css('visibility', 'visible');
  if(current>2)
    btn_prev.css('visibility', 'visible');
  else
    btn_prev.css('visibility', 'hidden');
  if(current>1){
    current--;
    var el=wrap.get(current-1);
    jQuery(el).stop(true,true).animate({marginLeft: 0}, 500);
  }
}

function getGameInfo(path,m_id){
  jQuery('#gameInfoBox').html("").dialog("destroy");
  jQuery('#gameInfoBox').load(path+'/matches_page.php?m_id='+m_id, function() {
    jQuery('#gameInfoBox').dialog({
      modal: true,
      open: initialize,
      width: 970,
      height: 500,
      show: "fade",
      hide: "fade",
      buttons: {
        "OK":function() {
					jQuery(this).dialog( "close" );
				}
      }
    });
  });
}

function initGamesBar(c){
  currentGame=c;
  var limit = jQuery(".small-bar").length>0 ? 3 : 5;
  if(currentGame==1)
    jQuery('.slide-win-prev').css('visibility', 'hidden');
  if(currentGame+limit>jQuery('#games .match-wrapper').length)
    jQuery('.slide-win-next').css('visibility', 'hidden');
}

function nextGame(){
  var wrap = jQuery('#games .match-wrapper');
  var btn_next = jQuery('.slide-win-next');
  var btn_prev = jQuery('.slide-win-prev');
  var limit = jQuery(".small-bar").length>0 ? 3 : 5;
  var mLeft = jQuery(".small-bar").length>0 ? -204 : -183;
  if(currentGame>0)
    btn_prev.css('visibility', 'visible');
  if(currentGame<(wrap.length-limit))
    btn_next.css('visibility', 'visible');
  else
    btn_next.css('visibility', 'hidden');
  if(currentGame<(wrap.length-(limit-1))){
    var el=wrap.get(currentGame-1);
    jQuery(el).stop(true,true).animate({marginLeft: mLeft}, 500);
    currentGame++;
  }
}

function prevGame(){
  var wrap = jQuery('#games .match-wrapper');
  var btn_next = jQuery('.slide-win-next');
  var btn_prev = jQuery('.slide-win-prev');
  var limit = jQuery(".small-bar").length>0 ? 1 : 3;
  if(currentGame<(wrap.length-limit))
    btn_next.css('visibility', 'visible');
  if(currentGame>2)
    btn_prev.css('visibility', 'visible');
  else
    btn_prev.css('visibility', 'hidden');
  if(currentGame>1){
    currentGame--;
    var el=wrap.get(currentGame-1);
    jQuery(el).stop(true,true).animate({marginLeft: 0}, 500);
  }
}